export const menuOpen = () => ({
  type: 'MENU_OPEN',
});

export const menuClose = () => ({
  type: 'MENU_CLOSE',
});
